/* eslint-disable @typescript-eslint/no-explicit-any */
export const parseJSON = <T = any>(str: string) => {
  try {
    const jsonValue: T = JSON.parse(str);
    return jsonValue;
  } catch {
    return undefined;
  }
};
